export default __webpack_public_path__ + "static/feature-banner-fiveglobalspots-d7ffea8b8ceece11bc05ed262e4f39fe.jpg";